export default {
  'confirm-yes': 'Yes, I confirm',
  copay: 'Copay:',
  cancel: 'Cancel',
  'order-status': 'Order status:',
  'order-canceled': 'Order canceled',
  'confirmed-back-to-pharmacy': 'Confirmed back to pharmacy',
  'on-its-way-to-pharmacy': 'On its way to the pharmacy',
  'back-to-pharmacy': 'Back to pharmacy',
  'patient-signature': 'Patient Signature',
  sign: 'Sign',
  'select-order-type': 'Select Order Type',
  'preferred-eta': 'Preferred ETA',
  'recipient-instructions': 'Recipient\'s Special Instructions',
  'add-special-instruction': 'Add special instruction',
  'unable-to-change-address': 'Unable to change address',
  'address-changed': 'Address changed successfully',
  'start-typing': 'Start typing',
  'full-address': 'Full Address',
  'street-address': 'Street Address',
  zip: 'ZIP',
  city: 'City',
  state: 'State',
  apt: 'Apt',
  'app-store': 'Download on the App Store',
  'track-all-orders': 'Track all your orders in one app',
  zoom: 'zoom',
  unzoom: 'unzoom',
  'close-photo': 'close',
  'feedback-call': 'Feedback Call',
  'feedback-message': 'Feedback Message',
  'feedback-close': 'Feedback Close',
  close: 'Close',
}
